import * as z from "zod/v4";

export const retryRyderWebhookSubscription = {
  name: "retryRyderWebhookSubscription" as const,
  input: z.object({}),
  output: z.object({}),
};
